<script lang="ts" setup>
  import useCopy from '@/common/composables/useCopy';

  const props = withDefaults(defineProps<{
    text?: string | number,
    icon?: string,
    message?: string,
    type?: string
    showNotification?: true
    tooltip?: string
  }>(), {
    icon: 'i-copy-o--16',
    type: 'ghost',
    showNotification: true
  });

  const { copyText, copyIcon } = useCopy({ icon: props.icon, showNotification: props.showNotification });

  defineExpose({
    copyText,
    copyIcon
  });
</script>

<template>
  <el-tooltip
    v-if="tooltip"
    class="v-copy-button"
    :content="tooltip"
    placement="top"
  >
    <el-button
      class="copy-button"
      data-testid="copy-button"
      :icon="copyIcon"
      :type="type"
      @click.stop="() => copyText(text || '', message)"
    >
      <slot />
    </el-button>
  </el-tooltip>
  <el-button
    v-else
    class="copy-button v-copy-button"
    data-testid="copy-button"
    :icon="copyIcon"
    :type="type"
    @click.stop="() => copyText(text || '', message)"
  >
    <slot />
  </el-button>
</template>
